import { render, staticRenderFns } from "./SecureExamWindow.vue?vue&type=template&id=fe21758e&scoped=true"
import script from "./SecureExamWindow.vue?vue&type=script&lang=js"
export * from "./SecureExamWindow.vue?vue&type=script&lang=js"
import style0 from "./SecureExamWindow.vue?vue&type=style&index=0&id=fe21758e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe21758e",
  null
  
)

export default component.exports